import { IRepertoireField } from "../types/IRepertoireField";
import { IAgreementState } from "../../redux/types/IAgreementState";
import { Dictionary, isEmpty } from "lodash";
import { IAgreementProductWorkDataItems } from "../types/IAgreementProductWorkDataItems";
import { IValidationMessage } from "../types/IValidationMessage";
import {
    AGREEMENT_SAVE_VALIDATION_AGREEMENT_CARVE_OUTS_INVALID,
    AGREEMENT_SAVE_VALIDATION_CARVE_OUT_DISABLED,
    AGREEMENT_SAVE_VALIDATION_CARVE_OUT_EMPTY,
    AGREEMENT_SAVE_VALIDATION_EFFECTIVE_TIMES_INVALID,
    AGREEMENT_SAVE_VALIDATION_IP_MATCHING_INVALID,
    AGREEMENT_SAVE_VALIDATION_SPECIFIC_AGREEMENT_CANNOT_HAVE_WORKS_AND_PRODUCT_WORKS,
    ARTIST_SAVE_VALIDATION_NAME_MISSING,
    DISTRIBUTION_SAVE_VALIDATION_AMOUNT_NOT_NUMERIC,
    DISTRIBUTION_SAVE_VALIDATION_DISTRIBUTION_NO_SET_TYPE,
    DISTRIBUTION_SAVE_VALIDATION_DISTRIBUTION_NO_SHARE_RIGHT_TYPE,
    DISTRIBUTION_SAVE_VALIDATION_EMPTY_ROW_DETECTED,
    DISTRIBUTION_SAVE_VALIDATION_NO_POOL_ASSIGNED,
    DISTRIBUTION_SAVE_VALIDATION_PERCENTAGE_NOT_100,
    DISTRIBUTION_SAVE_VALUE_PER_POINT_NOT_NUMERIC,
    DISTRIBUTION_TYPES_WITH_SUBJECTS,
    DROPDOWN_INPUT,
    IP_SAVE_VALIDATION_IP_TITLE_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_CREATION_CLASS_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_DATE_FROM_AFTER_TO,
    IP_SAVE_VALIDATION_REPRESENTATION_DATE_FROM_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_DATE_TO_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_ECONOMIC_RIGHT_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_POOL_WITHOUT_INCLUDE,
    IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_TERRITORY_INVALID,
    IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_TERRITORY_WITHOUT_INCLUDE,
    IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_EXCLUDE_TERRITORY_OVERLAP,
    IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_TERRITORY_INVALID,
    IP_SAVE_VALIDATION_REPRESENTATION_OVERLAPPING_RECORDS,
    IP_SAVE_VALIDATION_REPRESENTATION_ROLE_NOT_SET,
    IP_SAVE_VALIDATION_REPRESENTATION_SOCIETY_NAME_NOT_SET,
    LICENSE_AFFILIATED_USER_VALIDATION_MESSAGE,
    LICENSE_AUTHOR_SHARES_VALIDATION_MESSAGE,
    LICENSE_CART_NAME_VALIDATION_MESSAGE,
    LICENSE_COMMERCIAL_USE_VALIDATION_MESSAGE,
    LICENSE_GEOGRAPHICAL_AREA_VALIDATION_MESSAGE,
    LICENSE_RIGHTS_HOLDERS_SHARES_VALIDATION_MESSAGE,
    LICENSE_SECTOR_VALIDATION_MESSAGE,
    LICENSE_USER_TYPES_VALIDATION_MESSAGE,
    LICENSE_USES_VALIDATION_MESSAGE,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_AVAILABLE_FROM_DATE_NOT_SET_CONDITIONALLY,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_ID_NOT_SET,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_ID_NOT_ALPHANUMERIC,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_RUN_DATE_NOT_SET,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_STATUS_NOT_SET,
    PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_TYPE_NOT_SET,
    PRODUCT_SAVE_VALIDATION_DURATION_EXCEEDS_TOTAL,
    USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_EFFECTIVE_FROM_MANDATORY,
    USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_INVALID_NUMBER,
    USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_MANDATORY,
    USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_VALUE_SHOULD_BE_POSITIVE,
    USAGE_POOL_SAVE_VALIDATION_DATE_RANGES_OVERLAP,
    USAGE_POOL_SAVE_VALIDATION_DUPLICATE_DIMENSION_COMBINATION,
    USAGE_POOL_SAVE_VALIDATION_EFFECTIVE_DATE_RANGE_MANDATORY,
    USAGE_POOL_SAVE_VALIDATION_EVPP_EFFECTIVE_FROM_MANDATORY,
    USAGE_POOL_SAVE_VALIDATION_EVPP_INVALID_NUMBER,
    USAGE_POOL_SAVE_VALIDATION_EVPP_MANDATORY,
    USAGE_POOL_SAVE_VALIDATION_EVPP_VALUE_SHOULD_BE_POSITIVE,
    USAGE_POOL_SAVE_VALIDATION_FROM_DATE_AFTER_TO_DATE,
    USAGE_POOL_SAVE_VALIDATION_FROM_TIME_GREATER_THAN_TO_TIME,
    USAGE_POOL_SAVE_VALIDATION_WEIGHING_CODE_MANDATORY,
    WORK_SAVE_VALIDATION_ARTIST_NOT_SET,
    WORK_SAVE_VALIDATION_COMPONENT_INVALID,
    WORK_SAVE_VALIDATION_CONTRIBUTOR_SHARE_INVALID,
    WORK_SAVE_VALIDATION_NUMBER_NOT_SET,
    WORK_SAVE_VALIDATION_OTHER_EXCLUDE_INVALID,
    WORK_SAVE_VALIDATION_OTHER_EXCLUDE_WITHOUT_INCLUDE,
    WORK_SAVE_VALIDATION_OTHER_INCLUDE_EXCLUDE_CONFLICT,
    WORK_SAVE_VALIDATION_OTHER_INCLUDE_INVALID,
    WORK_SAVE_VALIDATION_SOURCE_NOT_SET,
    WORK_SAVE_VALIDATION_TITLE_NOT_SET,
    WORK_SAVE_VALIDATION_TITLE_TOO_LONG,
    IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_EXCLUDE_POOL_OVERLAP,
    USAGE_POOL_SAVE_VALIDATION_FROM_TIME_OR_TO_TIME_REQUIRED,
    WORK_SAVE_VALIDATION_PD_ARRANGEMENT_OVERRIDE_FAILED,
    WORK_SAVE_VALIDATION_PD_OVERRIDE_FAILED,
    WORK_SAVE_VALIDATION_PD_OVERRIDE_CHECKED_FAILED,
    WORK_SAVE_VALIDATION_PD_ARRANGEMENT_OVERRIDE_CHECKED_FAILED,
    WORK_SAVE_VALIDATION_PUBLIC_DOMAIN_CHECKED_FAILED,
    WORK_SAVE_VALIDATION_PD_ARRANGEMENT_CHECKED_FAILED
} from "../Consts";
import { IDistributionState } from "../../redux/types/IDistributionState";
import { ISocIP } from "../types/ISocIP";
import { IUsagePoolState } from "../../redux/types/IUsagePoolState";
import { IProductState } from "../../redux/types/IProductState";
import { IPaymentRunState } from "../../redux/types/IPaymentRunState";
import { IShoppingCartState } from "../../redux/types/IShoppingCartState";
import { IInterestedParty } from "../types/IInterestedParty";
import { IWorkState } from "../../redux/types/IWorkState";
import { IValidationContext } from "../../redux/types/IValidationContext";
import { TERRITORY_LOOKUP } from "../../lookup/Consts";
import { getAgencyLookupValues, getLookupValues } from "../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IArtist } from "../types/IArtist";
import { IContainedWork } from "../types/IContainedWork";
import { IContributorItem } from "../types/IContributorItem";
import { INumber } from "../types/INumber";
import { ITitle } from "../types/ITitle";
import { IWorksSearchResult } from "../types/IWorksSearchResult";
import { areAllObjectsUnique, checkDateValidation, checkFromTimeValidationWithDimensions, checkOverLappingDates, checkUniqueTimeRange, convertStringToList, isNullOrUndefined, isValidNumber } from "../../util/tools";
import { IArtistState } from "../../redux/types/IArtistState";
import { IIPRepresentation } from "../types/IIPRepresentation";
import { IDataItem } from "../types/IDataItem";
import { IUsagePool } from "../types/usageTypes/IUsagePool";
import { If } from "../../core/components/If";
import { IShareToleranceValueConfiguration } from "../types/IShareToleranceValueConfiguration";

export class ReporterFieldValidator {

    public static validate<T>(state: T, componentFields?: IRepertoireField[], additionalData?: IValidationContext, shareToleranceValue?: IShareToleranceValueConfiguration): IValidationMessage[] {
        let validationMessages: IValidationMessage[] = [];

        if (componentFields) {
            for (const field of componentFields.filter(f => f.isMandatory)) {
                const fieldValue = (state as any)[field.name];
                if (isEmpty(fieldValue)) {
                    validationMessages.push({ messageKey: `The field "${field.data}" is mandatory.` });
                }
            }
        }

        if (validationMessages.length === 0) {

            // // if - Work Validator
            if (ReporterFieldValidator.isWorkState(state)) {
                if (ReporterFieldValidator.isWorkState(state)) {
                    const {
                        writersContributorTypes = [],
                        publisherContributorTypes = [],
                        worksSearchResults = [],
                        lookups
                    } = additionalData || {};

                    const hasContainedWorks = !!state.components?.length;

                    if (!this.validateTitles(state.titles)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_TITLE_NOT_SET });
                    }

                    if (!this.validateTitleLengths(state.titles)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_TITLE_TOO_LONG });
                    }

                    if (!this.validateNumbers(state.numbers)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_NUMBER_NOT_SET });
                    }

                    if (!this.validateContributorsShares(state.contributors, hasContainedWorks, writersContributorTypes, publisherContributorTypes,shareToleranceValue)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_CONTRIBUTOR_SHARE_INVALID });
                    }

                    if (!this.validateArtists(state.artists)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_ARTIST_NOT_SET });
                    }

                    if (!state.source) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_SOURCE_NOT_SET });
                    }

                    if (hasContainedWorks && this.validateComponents(state.components, worksSearchResults)) {
                        validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_COMPONENT_INVALID });
                    }
                   
                    if (state.territorySpecificInfo && Array.isArray(state.territorySpecificInfo.workTerritorySpecificInfo)) {

                        state.territorySpecificInfo.workTerritorySpecificInfo.forEach((territory) => {
                            if ((territory.publicDomainDateOld == undefined && territory.publicDomainDate && !territory.isPublicDomainDateOverride)
                                || (territory.publicDomainDateOld && territory.publicDomainDate && territory.publicDomainDate !== territory.publicDomainDateOld && !territory.isPublicDomainDateOverride)) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PD_OVERRIDE_FAILED });
                            }
                            if (territory.isPublicDomainDateOverride && territory.publicDomainDate == undefined) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PD_OVERRIDE_CHECKED_FAILED });
                            }
                             if (territory.isPublicDomainDateOverride && territory.publicDomainDate && !territory.isOutOfCopyright) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PUBLIC_DOMAIN_CHECKED_FAILED });
                            }
                            if ((territory.pdArrangementDateOld == undefined && territory.pdArrangementDate && !territory.isPdArrangementDateOverride)
                                || (territory.pdArrangementDateOld && territory.pdArrangementDate && territory.pdArrangementDate !== territory.pdArrangementDateOld && !territory.isPdArrangementDateOverride)) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PD_ARRANGEMENT_OVERRIDE_FAILED });
                            }
                            if(territory.isPdArrangementDateOverride && territory.pdArrangementDate == undefined) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PD_ARRANGEMENT_OVERRIDE_CHECKED_FAILED });
                            }
                            if(territory.isPdArrangementDateOverride && territory.pdArrangementDate && !territory.isPDArrangement) {
                                validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_PD_ARRANGEMENT_CHECKED_FAILED });
                            }
                        });
                    }

                    const contributorsOther = state.contributors?.other || [];
                    Object.values(contributorsOther).forEach(c => {
                        const include = c.includeTerritories?.value || "";
                        const exclude = c.excludeTerritories?.value || "";

                        if (include.length === 0 && exclude.length !== 0) {
                            validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_OTHER_EXCLUDE_WITHOUT_INCLUDE });
                        }

                        if (!this.checkValidateTerritory(include, lookups)) {
                            validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_OTHER_INCLUDE_INVALID });
                        }

                        if (!this.checkValidateTerritory(exclude, lookups)) {
                            validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_OTHER_EXCLUDE_INVALID });
                        }

                        if (this.validateTerritoryAdded(include, exclude)) {
                            validationMessages.push({ messageKey: WORK_SAVE_VALIDATION_OTHER_INCLUDE_EXCLUDE_CONFLICT });
                        }
                    });
                }

            }

                // if - Agreement Validator
            else if (ReporterFieldValidator.isAgreementState(state)) {
                let applicableworks = state.agreementWorks || [];

                if ((state.agreementProductWorks.length > 0) && !state.licensedDirect) {
                    validationMessages.push({ messageKey: AGREEMENT_SAVE_VALIDATION_CARVE_OUT_DISABLED });
                }                

                if (state.agreementProductWorks.length > 0) {

                    if (applicableworks.length > 0)
                        validationMessages.push({ messageKey: AGREEMENT_SAVE_VALIDATION_SPECIFIC_AGREEMENT_CANNOT_HAVE_WORKS_AND_PRODUCT_WORKS });

                    //TODO: EM 2024/06/24. We need to discuss with QA people if removing this validation will be ok for the extension to the Carve Out Logic
                    //if (state.applicableWorksType != "INC")
                    //    validationMessages.push("specificAgreementWithTypeExcludeCannotHaveUsagePoolsOrProductWorks")
                }

                if (ReporterFieldValidator.invalidAgreementCarveOuts(state.agreementProductWorks))
                    validationMessages.push({ messageKey: AGREEMENT_SAVE_VALIDATION_AGREEMENT_CARVE_OUTS_INVALID });

                if (state.effectiveFrom && state.effectiveTo && (state.effectiveTo < state.effectiveFrom))
                    validationMessages.push({ messageKey: AGREEMENT_SAVE_VALIDATION_EFFECTIVE_TIMES_INVALID });

                if (state.agreementAdminIP.length > 0) {
                    let ipBaseNumbers = state.agreementAdminIP.map((ip) => ip.administeredByIPBaseNumber.value);
                    if (ipBaseNumbers.includes(state.ipBaseNumber))
                        validationMessages.push({ messageKey: AGREEMENT_SAVE_VALIDATION_IP_MATCHING_INVALID });
                }
            }

                // if - Distribution Validator
            else if (ReporterFieldValidator.isDistributionState(state)) {
                if ((!state?.distributionPools || state?.distributionPools.length == 0) && !state.isLivePerformancePortal)
                    validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_NO_POOL_ASSIGNED });

                if (state.distributionPools && !state.distributionPools.every(pool => !isNaN(Number(pool.amountToAllocate.value))))
                    validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_AMOUNT_NOT_NUMERIC });

                if (state.distributionPools && !state.distributionPools.every(pool => !isNaN(Number(pool.nominalValuePerPoint.value))))
                    validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALUE_PER_POINT_NOT_NUMERIC });

                if ((!state?.distributionSettings?.distributionSettingsSetTypeGroup?.value))
                    validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_DISTRIBUTION_NO_SET_TYPE });

                if ((!state?.distributionSettings?.distributionSettingsShareRightType?.value))
                    validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_DISTRIBUTION_NO_SHARE_RIGHT_TYPE });

                if (state.distributionPools?.length > 0) {
                    state.distributionPools.forEach((pool) => {
                        if (!pool.poolCode.value)
                            validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_EMPTY_ROW_DETECTED });
                    });
                }

                if (state.subjects && state.subjects.length > 0
                    && DISTRIBUTION_TYPES_WITH_SUBJECTS.includes(state.distributionType.replace(/\s+/g, ""))) {
                    const totalValue = state.subjects.reduce((sum, subject) => sum + Number(subject.value || 0), 0);
                    if (Math.round(totalValue * 100) / 100 !== 100) {
                        validationMessages.push({ messageKey: DISTRIBUTION_SAVE_VALIDATION_PERCENTAGE_NOT_100 });
                    }
                }
            }

                // if - Pools Validator
            else if (ReporterFieldValidator.isUsagePoolState(state)) {

                // Validate poolWeightSettings
                state.poolWeightSettings.forEach((element, index) => {
                    const row = `(row ${index + 1})`
                    if (isEmpty(element.effectiveDateRange?.value)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_EFFECTIVE_DATE_RANGE_MANDATORY, additionalInfo: row });
                    }
                    if (isEmpty(element.weightingCode?.value)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_WEIGHING_CODE_MANDATORY, additionalInfo: row });
                    }
                });

                // Validate poolEstimatedValuePerPointSettings
                state.poolEstimatedValuePerPointSettings.forEach(element => {
                    const evppValue = String(element.evpp?.value ?? "").trim();
                    if (isEmpty(evppValue)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_EVPP_MANDATORY });
                    } else if (!isValidNumber(evppValue)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_EVPP_INVALID_NUMBER });
                    } else if (parseFloat(evppValue) < 0) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_EVPP_VALUE_SHOULD_BE_POSITIVE });
                    }

                    if (isEmpty(element.effectiveFrom?.value)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_EVPP_EFFECTIVE_FROM_MANDATORY });
                    }
                });

                // Validate poolAmountMultipliers
                state.poolAmountMultipliers.forEach(element => {
                    const amountMultiplierValue = String(element.amountMultiplier?.value ?? "").trim();
                    if (isEmpty(amountMultiplierValue)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_MANDATORY });
                    } else if (!isValidNumber(amountMultiplierValue)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_INVALID_NUMBER });
                    } else if (parseFloat(amountMultiplierValue) < 0) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_VALUE_SHOULD_BE_POSITIVE });
                    }

                    if (isEmpty(element.effectiveFrom?.value)) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_AMOUNT_MULTIPLIER_EFFECTIVE_FROM_MANDATORY });
                    }
                });

                // Uniqueness checks
                const ignoreProps = ['weightMultiplier', 'weightingCode', 'copySection', 'poolWeightMultiplierID', 'poolID'];
                let allObjectsUniqueValidation = areAllObjectsUnique(state.poolWeightSettings, ignoreProps);
                if (allObjectsUniqueValidation.isInvalid) {
                    validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_DUPLICATE_DIMENSION_COMBINATION, additionalInfo: `(row ${allObjectsUniqueValidation.index + 1})` });
                }
                else {
                    let checkUniqueTimeRangeValidation = checkUniqueTimeRange(state.poolWeightSettings)
                    if (checkUniqueTimeRangeValidation.isInvalid) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_DUPLICATE_DIMENSION_COMBINATION, additionalInfo: `(row ${checkUniqueTimeRangeValidation.index + 1})` });
                    }
                }

                let fromTimeValidationMissingOnly = checkFromTimeValidationWithDimensions(state.poolWeightSettings, state.datesAndDimensions, true);
                if (fromTimeValidationMissingOnly.isInvalid) {
                    validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_FROM_TIME_OR_TO_TIME_REQUIRED, additionalInfo: `(row ${fromTimeValidationMissingOnly.index + 1})` });
                }
                else {                
                    let fromTimeValidation = checkFromTimeValidationWithDimensions(state.poolWeightSettings, state.datesAndDimensions);
                    if (fromTimeValidation.isInvalid) {
                        validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_FROM_TIME_GREATER_THAN_TO_TIME, additionalInfo: `(row ${fromTimeValidation.index + 1})` });
                    }
                }

                if (checkOverLappingDates(state.poolEstimatedValuePerPointSettings)) {
                    validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_DATE_RANGES_OVERLAP });
                }

                if (checkDateValidation(state.poolEstimatedValuePerPointSettings))
                {
                    validationMessages.push({ messageKey: USAGE_POOL_SAVE_VALIDATION_FROM_DATE_AFTER_TO_DATE });
                }
            }

                // if - Product Validator
            else if (ReporterFieldValidator.isProductState(state)) {
                if (
                    state.productType === 'CUE SHEET' &&
                    state.duration > state.productAVWork?.totalDuration &&
                    state.productAVWork?.totalDuration > 0
                ) {
                    validationMessages.push({ messageKey: PRODUCT_SAVE_VALIDATION_DURATION_EXCEEDS_TOTAL });
                }
            }

                // if - PaymentRun Validator
            else if (ReporterFieldValidator.isPaymentRunState(state)) {
                if (!state.paymentRunDate)
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_RUN_DATE_NOT_SET });

                if (!state.code)
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_ID_NOT_SET });

                let allowableCharactersRegex = /^[a-z0-9\-_ ]+$/i;
                if (state.code && !allowableCharactersRegex.test(state.code)) {
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_ID_NOT_ALPHANUMERIC });
                }

                if (!state.status)
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_STATUS_NOT_SET });

                if (!state.type)
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_TYPE_NOT_SET });

                if (state.availableOnPortalTo && !state.availableOnPortalFrom)
                    validationMessages.push({ messageKey: PAYMENTRUN_SAVE_VALIDATION_PAYMENTRUN_AVAILABLE_FROM_DATE_NOT_SET_CONDITIONALLY });
            }

                // if - License Validator
            else if (ReporterFieldValidator.isLicenseState(state)) {

                if (!state.userName?.value) {
                    validationMessages.push({ messageKey: LICENSE_AFFILIATED_USER_VALIDATION_MESSAGE });
                }
                if (!state.shoppingCartName?.value) {
                    validationMessages.push({ messageKey: LICENSE_CART_NAME_VALIDATION_MESSAGE });
                }
                if (!state.uses?.value) {
                    validationMessages.push({ messageKey: LICENSE_USES_VALIDATION_MESSAGE });
                }
                if (!state.commercialUse?.value) {
                    validationMessages.push({ messageKey: LICENSE_COMMERCIAL_USE_VALIDATION_MESSAGE });
                }
                if (!state.geographicalArea?.value) {
                    validationMessages.push({ messageKey: LICENSE_GEOGRAPHICAL_AREA_VALIDATION_MESSAGE });
                }
                if (!state.sector?.value) {
                    validationMessages.push({ messageKey: LICENSE_SECTOR_VALIDATION_MESSAGE });
                }
                if (!state.userTypes?.value) {
                    validationMessages.push({ messageKey: LICENSE_USER_TYPES_VALIDATION_MESSAGE });
                }

                if (state.licenseRequests[0].licenseRequestWorks.some(w => (w.percentageVA + w.percentageVE) !== 100)) {
                    validationMessages.push({ messageKey: LICENSE_RIGHTS_HOLDERS_SHARES_VALIDATION_MESSAGE });
                }

                if (state.licenseRequests[0].licenseRequestWorks.some(w => (w.percentageVAA + w.percentageVAT) > w.percentageVA)) {
                    validationMessages.push({ messageKey: LICENSE_AUTHOR_SHARES_VALIDATION_MESSAGE });
                }
            }

            // if - InterestedPartyOnSave Validator
            else if (ReporterFieldValidator.isInterestedPartyOnSave(state)) {

                const { lookups, usagePools } = additionalData || {};
                const ipRepresentations = state.ipRepresentations || [];
                const ignoringProps = [
                    'agencyID', 'agencyName', 'amendedDateTime', 'applicableTerritories',
                    'economicRightDescription', 'externalReferenceID', 'isAgreementEnded',
                    'isDeleted', 'isWorld', 'lastModifiedDate', 'representationID',
                    'sharePercentage', 'signedDate', 'socIPID', 'territories', 'shareSet',
                    'fromDate', 'toDate', 'societyName'
                ];

                ipRepresentations.forEach(ip => {
                    const { fromDate, toDate, creationClass, economicRights, societyName, role, includeTerritories, excludeTerritories, includePools, excludePools } = ip;

                    if (!fromDate?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_DATE_FROM_NOT_SET });
                    if (!toDate?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_DATE_TO_NOT_SET });
                    if (!creationClass?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_CREATION_CLASS_NOT_SET });
                    if (!economicRights?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_ECONOMIC_RIGHT_NOT_SET });
                    if (!societyName?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_SOCIETY_NAME_NOT_SET });
                    if (!role?.value) validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_ROLE_NOT_SET });

                    const includeTerr = includeTerritories?.value || "";
                    const excludeTerr = excludeTerritories?.value || "";
                    const includePoolsVal = includePools?.value || "";
                    const excludePoolsVal = excludePools?.value || "";

                    if (includeTerr.length === 0 && excludeTerr.length !== 0) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_TERRITORY_WITHOUT_INCLUDE });
                    }

                    if (!ReporterFieldValidator.checkValidateTerritory(includeTerr, lookups)) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_TERRITORY_INVALID });
                    }

                    if (!ReporterFieldValidator.checkValidateTerritory(excludeTerr, lookups)) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_TERRITORY_INVALID });
                    }

                    if (ReporterFieldValidator.validateTerritoryAdded(includeTerr, excludeTerr)) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_EXCLUDE_TERRITORY_OVERLAP });
                    }

                    if (includePoolsVal.length === 0 && excludePoolsVal.length !== 0) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_EXCLUDE_POOL_WITHOUT_INCLUDE });
                    }

                    if (ReporterFieldValidator.validateTerritoryAdded(includePoolsVal, excludePoolsVal)) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_INCLUDE_EXCLUDE_POOL_OVERLAP });
                    }

                    const from = new Date(fromDate?.value);
                    const to = new Date(toDate?.value);
                    if (from > to) {
                        validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_DATE_FROM_AFTER_TO });
                    }
                });

                if (ReporterFieldValidator.hasOverlappingRecords(ipRepresentations, lookups, usagePools, ignoringProps)) {
                    validationMessages.push({ messageKey: IP_SAVE_VALIDATION_REPRESENTATION_OVERLAPPING_RECORDS });
                }
            }

                // if - InterestedParty Validator
            else if (ReporterFieldValidator.isInterestedPartyMergeObject(state)) {
                if (!state.fromIP || !state.toIP) {
                    validationMessages.push({ messageKey: IP_SAVE_VALIDATION_IP_TITLE_NOT_SET });
                }
            }

                // if - Artist Validator
            else if (ReporterFieldValidator.isArtistState(state)) {
                if (isEmpty(state.firstName?.trim()) && isEmpty(state.lastName?.trim())) {
                    validationMessages.push({ messageKey: ARTIST_SAVE_VALIDATION_NAME_MISSING });
                }
            }

            else {
                throw new Error("FieldValidator.validate: Undefined case for passed entity type to FieldValidator.ts");
            }
        }
        return validationMessages;
    }

    // type guard
    private static isWorkState(state: any): state is IWorkState {
        return (state as IWorkState).workID !== undefined && (state as IWorkState).titles !== undefined;
    }

    private static isAgreementState(state: any): state is IAgreementState {
        return (state as IAgreementState).agreementID !== undefined;
    }

    private static isDistributionState(state: any): state is IDistributionState {
        return (state as IDistributionState).distributionID !== undefined;
    }

    private static isInterestedPartyOnSave(state: any): state is ISocIP {
        return (
            state &&
            (state.accountType !== undefined || state.accountNumber !== undefined)
        );
    }

    private static isUsagePoolState(state: any): state is IUsagePoolState {
        return (state as IUsagePoolState).poolID !== undefined;
    }

    private static isProductState(state: any): state is IProductState {
        return (state as IProductState).productCoreID !== undefined;
    }

    private static isPaymentRunState(state: any): state is IPaymentRunState {
        return (state as IPaymentRunState).paymentRunID !== undefined;
    }

    private static isLicenseState(state: any): state is IShoppingCartState {
        return (state as IShoppingCartState).shoppingCartID !== undefined;
    }

    private static isInterestedPartyMergeObject(state: any): state is { fromIP: IInterestedParty, toIP: IInterestedParty } {
        return typeof state === 'object' && 'fromIP' in state && 'toIP' in state;
    }

    private static isArtistState(state: any): state is IArtistState {
        return (state as IArtistState).type !== undefined;
    }


    // Work
    private static validateTitles(titles: ITitle[]): boolean {
        let originalTitleCount: number;
        let emptyTitles: boolean;

        originalTitleCount = 0;
        emptyTitles = false;

        titles.forEach(w => {
            if (w.type.value === "OT") {
                originalTitleCount++;
            }
            if (w.title.value == null || String(w.title.value).trim() === '') {
                emptyTitles = true;
            }
        })

        return (originalTitleCount === 1 && !emptyTitles);
    }

    private static validateTitleLengths(titles: ITitle[]): boolean {

        let titleTooLong: boolean;

        titleTooLong = false;

        titles.forEach(w => {
            if (w.title.value.length > 500) {
                titleTooLong = true;
            }
        })

        return !titleTooLong;

    }

    private static validateNumbers(numbers: INumber[]): boolean {
        let emptyNumbers: boolean;

        emptyNumbers = false;

        numbers.forEach(w => {
            if (!w.number.value) {
                emptyNumbers = true;
            }
        })

        return !emptyNumbers;
    }

    private static validateContributorsShares(contributors: Dictionary<IContributorItem[]>,
        hasContainedWorks: boolean,
        workContributorTypes: string[],
        publisherContributorTypes: string[],
        shareToleranceValue?: IShareToleranceValueConfiguration): boolean {
        const flattenedContributors: IContributorItem[] = [];

        if (contributors) {
            for (var key in contributors) {
                flattenedContributors.push(...contributors[key]);
            }

            var publisherShareValid = true;
            var authorShareValid = true;
            var translatorShareValid = true;

            var perfMechValidation = flattenedContributors.every(c =>
            ((!c.perfPercentage.value || c.perfPercentage.value <= shareToleranceValue?.ToleranceUpperPerformer)
                && (!c.mechPercentage.value || c.mechPercentage.value <= shareToleranceValue?.ToleranceUpperMechanical)));


            if (flattenedContributors.every(c =>
                (c.copyLevyPercentage && c.copyLevyPercentage.value != undefined)
                && c.copyLicencePercentage && c.copyLicencePercentage.value != undefined)) {

                let translatorTypes = workContributorTypes?.filter(x => x.endsWith('T'));
                let authorTypes = workContributorTypes?.filter(x => !x.endsWith('T'));

                if (translatorTypes && authorTypes && publisherContributorTypes) {
                    let publishers = flattenedContributors.filter(i => publisherContributorTypes.includes(i.role.value))
                    let authors = flattenedContributors.filter(i => authorTypes.includes(i.role.value))
                    let translators = flattenedContributors.filter(i => translatorTypes.includes(i.role.value))

                    publisherShareValid = publishers.every(c =>
                    (c.copyLevyPercentage.value <= 100
                        && c.copyLicencePercentage.value <= 100));

                    translatorShareValid = translators.every(t =>
                    (t.copyLicencePercentage.value <= 100
                        && t.copyLevyPercentage.value <= 100));

                    authorShareValid = authors.every(a =>
                    (a.copyLevyPercentage.value <= 100
                        && a.copyLicencePercentage.value <= 100));
                }
            }

            if (!perfMechValidation || !publisherShareValid || !authorShareValid || !translatorShareValid) {
                return false;
            }
            else {
                return true;
            }
        }
        else
            return !hasContainedWorks;
    }

    private static validateArtists(artists: IArtist[]): boolean {
        let emptyArtists: boolean;
        let hasType: boolean;

        emptyArtists = false;
        hasType = true;

        artists.forEach(w => {
            if (!w.type) {
                hasType = false;
            }
            if (!w.firstName && !w.lastName) {
                emptyArtists = true;
            }
        })

        return hasType && !emptyArtists;
    }

    private static validateComponents(components: IContainedWork[], worksSearchResults: IWorksSearchResult[]): boolean {

        let inValidComponent: boolean;
        inValidComponent = false;
        components.forEach(w => {
            if (worksSearchResults != undefined) {
                const work = worksSearchResults.filter((c) => c.workID === w.workCode);
                if (work[0]?.compoundType !== null && work[0]?.compoundType !== undefined && work[0]?.compoundType !== "") {
                    inValidComponent = true;

                }
            }
        })
        return inValidComponent;

    }

    public static validateIncludeTerritory(territory: string): boolean {
        return isNullOrUndefined(territory) ? false : true;
    }
    public static validateExcludeTerritory(territory: string): boolean {
        return isNullOrUndefined(territory) ? false : true;
    }
    public static checkValidateTerritory(territory: string, lookups?: ILookupDictionary): boolean {
        if (territory.length > 0) {
            let resultTerritory = territory.split(',');
            let territoriesLookup = getLookupValues(TERRITORY_LOOKUP, lookups);
            let territoryCodes = territoriesLookup.map(item => item.code);
            return resultTerritory.every(item => territoryCodes.includes(item.toUpperCase()));
        } else {
            return true;
        }
    }

    public static validateTerritoryAdded(territoryInclude: string, territoryExclude: string): boolean {
        let territoriesInclude;
        let territoriesExclude;
        if (territoryInclude && territoryExclude) {
            territoriesInclude = territoryInclude.split(',').map(item => item.toUpperCase());
            territoriesExclude = territoryExclude.split(',').map(item => item.toUpperCase());
            const setA = new Set(territoriesInclude);
            return territoriesExclude.some(item => setA.has(item))

        }
    }  

    // Agreement
    public static invalidAgreementCarveOuts(carveOuts: IAgreementProductWorkDataItems[]): boolean {
        let badpools: IAgreementProductWorkDataItems[] = [];
        let ids: { [key: number]: string } = {};
        carveOuts.forEach((row) => {
            if ((!isEmpty(ids) && (!!(ids[row.productNumber.value] === "") != !!(row.workName.value === ""))) || ids[row.productNumber.value] === row.workName.value) {
                badpools.push(row);
            } else {
                ids[row.productNumber.value] = row.workName.value;
            }
        });
        return badpools.length > 0
    }

    // InterestedPartyOnSave
    private static hasOverlappingRecords(
        records: IIPRepresentation[],
        lookups: ILookupDictionary,
        usagePools: IUsagePool[],
        ignoringProps: string[]
    ): boolean {
        const agencyLookup = getAgencyLookupValues(lookups, true);
        let overlap = false;

        for (let i = 0; i < records.length; i++) {
            for (let j = i + 1; j < records.length; j++) {
                const rec1 = records[i], rec2 = records[j];
                const from1 = new Date(rec1.fromDate.value);
                const to1 = new Date(rec1.toDate.value);
                const from2 = new Date(rec2.fromDate.value);
                const to2 = new Date(rec2.toDate.value);

                const datesOverlap = from1 <= to2 && from2 <= to1;
                const areEqual = ReporterFieldValidator.areRecordsEqual(rec1, rec2, usagePools, lookups);

                if (datesOverlap && areEqual) {
                    const updatedArray = [rec1, rec2].map(item => {
                        const code = item.agencyID ?? item.societyName?.value;
                        const match = agencyLookup?.find(x => x.code === code);
                        return {
                            ...item,
                            societyName: { value: match?.description || "", inputType: DROPDOWN_INPUT }
                        };
                    });

                    let areAllObjectsUniqueValidation = areAllObjectsUnique(updatedArray, ignoringProps);
                    if (areAllObjectsUniqueValidation.isInvalid) {
                        const ti1 = rec1.includeTerritories.value.split(',');
                        const ti2 = rec2.includeTerritories.value.split(',');
                        if (ReporterFieldValidator.areArraysOverlapping(ti1, ti2)) {
                            overlap = true;
                        }
                    }

                    if (overlap) return true;
                }
            }
        }

        return overlap;
    }

    private static areRecordsEqual(
        rec1: IIPRepresentation,
        rec2: IIPRepresentation,
        usagePools: IUsagePool[],
        lookups: ILookupDictionary
    ): boolean {
        return (
            rec1.creationClass?.value === rec2.creationClass?.value &&
            rec1.economicRights?.value === rec2.economicRights?.value &&
            rec1.role?.value === rec2.role?.value &&
            ReporterFieldValidator.includeExcludeAreEqual(rec1.includeTerritories, rec1.excludeTerritories, rec2.includeTerritories, rec2.excludeTerritories, null, null, lookups) &&
            ReporterFieldValidator.includeExcludeAreEqual(rec1.includePools, rec1.excludePools, rec2.includePools, rec2.excludePools, usagePools, rec1.economicRights, null)
        );
    }

    private static includeExcludeAreEqual(
        include1: IDataItem,
        exclude1: IDataItem,
        include2: IDataItem,
        exclude2: IDataItem,
        usagePools: IUsagePool[] = null,
        economicRight: IDataItem = null,
        lookups: ILookupDictionary = null
    ): boolean {
        if (include1?.value === include2?.value && exclude1?.value === exclude2?.value) return true;

        let include1List = convertStringToList(include1);
        let include2List = convertStringToList(include2);
        let exclude1List = convertStringToList(exclude1);
        let exclude2List = convertStringToList(exclude2);

        if (include1?.value === include2?.value) {
            return exclude1List.length === exclude2List.length && exclude1List.every(i => exclude2List.includes(i));
        }

        if (usagePools && (include1?.value === "ALL" || include2?.value === "ALL")) {
            const allPools = usagePools
                .filter(k => k.rights.every(r => r.economicRight === economicRight?.value))
                .map(x => x.poolCode);
            include1List = include1?.value === "ALL" ? allPools : include1List;
            include2List = include2?.value === "ALL" ? allPools : include2List;
        }

        if (lookups && (include1?.value === "2WL" || include2?.value === "2WL")) {
            const allTerritories = getLookupValues(TERRITORY_LOOKUP, lookups).map(t => t.code);
            include1List = include1?.value === "2WL" ? allTerritories : include1List;
            include2List = include2?.value === "2WL" ? allTerritories : include2List;
        }

        include1List = exclude1List[0] !== "2WL" ? include1List.filter(i => !exclude1List.includes(i)) : [];
        include2List = exclude2List[0] !== "2WL" ? include2List.filter(i => !exclude2List.includes(i)) : [];

        return include1List.length === include2List.length && include1List.every(i => include2List.includes(i));
    }

    private static areArraysOverlapping(arr1: string[], arr2: string[]): boolean {
        return arr1.some(item => arr2.includes(item));
    }

}
